import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getVendors } from "@tKgpco/Services/CustomVendorsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Vendor } from "@tKgpco/Store/Data/Vendors/VendorsState";

interface onError {
    onError?: (message: string) => string | void;
}
type ReportParameterParam = HasOnSuccess & onError;

type HandlerType = CustomApiHandler<ReportParameterParam, Vendor[]>;

export const startFetchingData: HandlerType = props => {
    props.dispatch({
        type: "Data/Custom/StartFetchingVendors",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await getVendors()) as Vendor[];
        props.dispatch({
            type: "Data/Custom/CompleteFetchingVendors",
            vendors: props.apiResult,
        });
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        if (isApiError(error) && error.status === 500) {
            props.parameter.onError?.("Internal Server Error");
            return false;
        }
        throw error;
    }
};

export const chain = [startFetchingData, RequestDataFromApi];

const vendorsHandler = createHandlerChainRunner(chain, "getReport");
export default vendorsHandler;
